import { useTranslation } from 'react-i18next'

import { useListPaymentMethodsApiV1PaymentMethodsGet } from '#/shared/api/generated/billing/theCargoBilling'
import type { SelectOption } from '#/shared/ui/select'

import { isCardChargeMethod } from './payment-values'

const PAYMENT_METHOD_ACTIVE_STATUS = 'active'

interface MethodOptionsResult {
  options: SelectOption[]
  isLoading: boolean
}

export function usePaymentMethodOptions(enabled: boolean): MethodOptionsResult {
  const { t } = useTranslation()
  const { data, isLoading } = useListPaymentMethodsApiV1PaymentMethodsGet(
    { size: 100, status: PAYMENT_METHOD_ACTIVE_STATUS },
    { query: { enabled } },
  )
  const items = data?.data.items ?? []
  const seen = new Set<string>()
  const types: string[] = []
  for (const item of items) {
    if (seen.has(item.type)) continue
    seen.add(item.type)
    types.push(item.type)
  }
  // With several merchants configured each one gets its own chip so the user
  // picks which to charge through; a lone gateway needs no merchant name and
  // reads as plain "Card".
  const collapseCardLabel = types.filter(isCardChargeMethod).length === 1
  const options = types.map((type) => ({
    value: type,
    label:
      collapseCardLabel && isCardChargeMethod(type)
        ? t('adminPaymentMethods.typeLabel.card')
        : t(`adminPaymentMethods.typeLabel.${type}`),
  }))
  return { options, isLoading: enabled && isLoading }
}
